import React from 'react';
import { Flex } from '@withjoy/joykit';
import { ContactQuarantinedMessageBatchFilter, QuarantineStatus } from '@graphql/generated';
import Card from './Card';

type SpamFiltersProps = {
  onSelectFilter: (filterKey: keyof ContactQuarantinedMessageBatchFilter, value: string) => void;
  activeFilters: ContactQuarantinedMessageBatchFilter;
};

export const SpamFilters = (props: SpamFiltersProps) => {
  const { onSelectFilter, activeFilters } = props;

  return (
    <Flex
      gap="1rem"
      overflowX="scroll"
    >
      <Card
        header="Unreads"
        text="Click to view messages that need to be reviewed"
        selected={activeFilters.quarantineStatus === QuarantineStatus.review}
        onClick={() => {
          onSelectFilter('quarantineStatus', QuarantineStatus.review);
        }}
      />
      <Card
        header="Approved"
        text="View accepted message history"
        selected={activeFilters.quarantineStatus === QuarantineStatus.approved}
        onClick={() => {
          onSelectFilter('quarantineStatus', QuarantineStatus.approved);
        }}
      />
      <Card
        header="Denied"
        text="View rejected message history"
        selected={activeFilters.quarantineStatus === QuarantineStatus.rejected}
        onClick={() => {
          onSelectFilter('quarantineStatus', QuarantineStatus.rejected);
        }}
      />
    </Flex>
  );
};
